/*
 * @Author: libo 
 * @Date: 2020-11-13 17:44:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-02-16 10:35:46
 *
<template>
  <a-modal
    :title="title"
    :width=width
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
    </template>
    <div class="table-operator" style="display:flex;justify-content:flex-end;" v-if="this.tabKey <= 1">
      <a-button type="primary" icon="download" @click="handleExportXls($t('月报表详情'))">{{ $t('导出') }}</a-button>
    </div>
    <a-spin :spinning="confirmLoading">
      <div>
        <a-tabs v-model="tabKey" @change="changeTab">
          <a-tab-pane key="1" :tab="$t('列表数据')">
            <a-table 
              :columns="columns"
              tableLayout="fixed"
              :data-source="list"
              rowKey='reportMonthDay'
              :pagination="ipagination"
              @change="handleTableChange"
              class="j-table-force-nowrap"
            >
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('图表展示')" force-render>
            <Echart ref="option" :options="option" class="option"></Echart>
          </a-tab-pane>
        </a-tabs>
      </div> 
    </a-spin>
  </a-modal>
</template>

<script>
  import { downFile, getAction,putAction } from '@/api/manage'
  import { validateDuplicateValue,listSize } from '@/utils/util'
  import {isUndefined} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  import echarts from 'echarts/lib/echarts';
  import moment from 'moment'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterMonthlyStatementModal',
    components: {
      // DetailList,
      // DetailListItem,
    },
    data () {
      return {
        list: [],
        title: this.$t('操作'),
        visible: false,
        disableSubmit:false,
        model: {},
        queryParam:{},
        filters: {},
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask: "/jeecg-charge/meter/userPay/doPayTask",
          UserRecordList: "/jeecg-charge/meter/meterUserPayRecord/monthReportDetail", //详情查询接口
          exportXlsUrl: "jeecg-charge/meter/meterUserWaterReportDay/exportXlsForMonthUseDetailList", //导出接口
        },
        tabKey: '1',
        width: 1000,
        option: {}
      }
    },
    created () {
    },
    computed: {
      // i18n：列定义使用 computed 以响应语言切换
      columns() {
        return [
        {
          title: this.$t('日期'),
          dataIndex: 'reportMonthDay',
          align:"center",
        },
        {
          title: this.$t('交易条数'),
          dataIndex: 'dayRecordCount',
          align:"center",
        },
        {
          title: this.$t('退费金额(元)'),
          dataIndex: 'daySumBack',
          align:"center",
        },
        {
          title: this.$t('充值金额(元)'),
          dataIndex: 'daySumPay',
          align:"center",
        },
        {
          title: this.$t('营收金额(元)'),
          dataIndex: 'daySumRevenue',
          align:"center",
        }]
      },
    },
    methods: {
      handleExportXls(fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        let param = {...this.queryParam};
        param.createBy = this.model.createBy
        param.reportDate = this.model.reportDate
        param.userAccountPayType = this.model.userAccountPayType
        param.waterTypeId = this.model.waterTypeId
        param.reportDate = this.queryParam.reportMonth;
        if(this.selectedRowKeys && this.selectedRowKeys.length>0){
          param['selections'] = this.selectedRowKeys.join(",")
        }
        console.log("导出参数",param)
        downFile(this.url.exportXlsUrl,param).then((data)=>{
          if (!data) {
            this.$message.warning(this.$t("文件下载失败"))
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      handleOk(e) {
        console.log(e);
        this.visible = false;
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.queryUserRecordList();
      },
      queryUserRecordList() {  //详情
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.createBy = this.model.createBy
        params.reportDate = this.model.reportDate
        params.userAccountPayType = this.model.userAccountPayType
        params.waterTypeId = this.model.waterTypeId
        params.reportDate = this.queryParam.reportMonth;
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
            this.list = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      edit (queryParam,record) {
        this.queryParam = Object.assign({}, record);
        this.model = Object.assign({}, queryParam);
        this.visible = true;
        console.log(this.model);
        console.log(this.queryParam);
        this.$nextTick(() => {
        // this.form.setFieldsValue(pick(this.model,))
        })
        this.queryUserRecordList();
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.tabKey = this.$options.data.call(this).tabKey
        this.option = this.$options.data.call(this).option
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      changeTab(e) {
        if(e==2){
          this.dealData(this.list)
        }
      },
      dealData(list) {
        console.log(list)
        let categoryData = []
        let seriesData = []
        for(let i=0;i<list.length;i++) {
          categoryData.push(list[i].reportMonthDay)
          seriesData.push(list[i].daySumRevenue)
        }
        this.setOption(categoryData,seriesData)
      },
      setOption(categoryData,seriesData) {
        this.option = {
          backgroundColor: '#e6f7ff',
          title: {
              text: this.$t('元'),
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 16,
                  color: '#000000'
              },
              top: '0%',
              left: '3%'
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              },
              formatter: '{b0}<br />{a0}:{c0}'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
              type: 'category',
              data: categoryData,
              axisLine: {
                  lineStyle: {
                      color: 'rgba(255,255,255,0.12)'
                  }
              },
              axisLabel: {
                  margin: 10,
                  //color: '#e2e9ff',
                  textStyle: {
                      fontSize: 14
                  },
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#233e64'
                }
              },
          }],
          yAxis: [{
              splitNumber: 3,
              axisLabel: {
                  formatter: '{value}',
                  //color: '#e2e9ff',
              },
              axisLine: {
                  show: false
              },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D4F2E7'
            }
          },
          }],
          series: [{
              type: 'line',
              name: this.$t('营收金额'),
              data: seriesData,
              barMaxWidth: 14,
              itemStyle: {
                  normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                          offset: 0,
                          color: 'rgba(0,210,255,1)' // 0% 处的颜色
                      }, {
                          offset: 1,
                          color: 'rgba(58,123,213,1)' // 100% 处的颜色
                      }], false),
                      barBorderRadius: [30, 30, 30, 30],
                      shadowColor: 'rgba(0,160,221,1)',
                      //shadowBlur: 4,
                  }
              }
          },{
              type: 'bar',
              data: seriesData,
              barMaxWidth: 14,
              itemStyle: {
                  normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                          offset: 0,
                          color: 'rgba(0,210,255,1)' // 0% 处的颜色
                      }, {
                          offset: 1,
                          color: 'rgba(58,123,213,1)' // 100% 处的颜色
                      }], false),
                      barBorderRadius: [30, 30, 30, 30],
                      shadowColor: 'rgba(0,160,221,1)',
                      //shadowBlur: 4,
                  }
              }
          }]
        }
      },
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
.option{
  min-height: 400px;
}
</style>